// Customer credentials must never fall back to an employee's browser login.
export const portalRequest = (session, options = {}) => ({
  ...options, isolatedAuth: true, authToken: session || null,
});

const RETURN_KEY = 'clientPortalOrderReturn';
const storage = () => process.env.REACT_APP_CLIENT_APP === 'true' ? localStorage : sessionStorage;
export const rememberOrderReturn = order => {
  if (order && order.length <= 255) storage().setItem(RETURN_KEY, JSON.stringify({ order, created: Date.now() }));
};
export const clearOrderReturn = () => storage().removeItem(RETURN_KEY);
export const pendingOrderReturn = () => {
  try {
    const value = JSON.parse(storage().getItem(RETURN_KEY));
    if (typeof value?.order === 'string' && value.order.length <= 255 && value.order.length > 0
      && value.created <= Date.now() && Date.now() - value.created < 60 * 60 * 1000) return value.order;
  } catch { /* Navigation state never grants access. */ }
  clearOrderReturn();
  return null;
};
